import React from 'react';
import { withErrorBoundary } from '../../../hoc/withErrorBoundary';

const IssueDetail = withErrorBoundary(
  React.lazy(
    () => import('../../../micro-frontends/components/IssueDetail'),
  ),
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const IssueDetailView = (props: any) => {
  return <IssueDetail {...props.data} />;
};
